import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'
import Product from '../views/ProductPage.vue'
import AboutUs from '../views/AboutPage.vue'
import ContactUs from '../views/ContactPage.vue'
import ProductDetail from '../views/ProductDetailPage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUs
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs
  },
  {
    path: '/product',
    name: 'product',
    component: Product
  },
  {
    path: '/product-detail/:slug',
    name: 'product-detail',
    component: ProductDetail
  },
  // Add other routes as needed
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router